import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthStatusService {
  public stateSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loggedIn = this.stateSource.asObservable();

  constructor() { }

  setState(value: boolean) {
    this.stateSource.next(value);
  }
}
